/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_TitleInputs */

const en_pc_online_compat_title = /** @type {(inputs: Pc_Online_Compat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browsers and large files`)
};

const zh_pc_online_compat_title = /** @type {(inputs: Pc_Online_Compat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器与大文件`)
};

/**
* | output |
* | --- |
* | "Browsers and large files" |
*
* @param {Pc_Online_Compat_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_title = /** @type {((inputs?: Pc_Online_Compat_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_title(inputs)
	return zh_pc_online_compat_title(inputs)
});
export { pc_online_compat_title as "pc.online.compat_title" }